import formatDate from '@utils/format-date'
import formatPaymentMethod from '@utils/format-payment-method'

const orderPrepaidTitleMap = {
  0: '已取消',
  1: '已付款',
  2: '未付款',
};

const orderPrepaidColorMap = {
  0: 'gray-1',
  1: 'primary',
  2: 'danger',
};

const orderPrepaidInfoColorMap = {
  0: 'warn',
  1: 'text',
  2: 'danger',
};

export default function formatOrderPrepaid(status, orderItem = {}) {
  return {
    title: formatOrderPrepaidStatusTitle(status),
    color: formatOrderPrepaidColor(status),
    infoColor: formatOrderPrepaidInfoColor(status),
    paidInfo: formatOrderPrepaidPaidInfo(orderItem),
  }
}

export function formatOrderPrepaidStatusTitle(status) {
  return orderPrepaidTitleMap[status]
}

export function formatOrderPrepaidColor(status) {
  return orderPrepaidColorMap[status]
}

export function formatOrderPrepaidInfoColor(status) {
  return orderPrepaidInfoColorMap[status]
}

export function formatOrderPrepaidPaidInfo({
  status,
  cancelDate,
  paidDate,
  paymentExpiredDate,
  paymentMethod,
  allowExpired = 1
} = {}) {
  if(status) {
    const orderPrepaidPaidInfoMap = {
      0: `於${formatDate(cancelDate, 'dateWeekDay')} 取消`,
      1: `${formatDate(paidDate, 'dateWeekDay')} ${formatPaymentMethod(paymentMethod)}`,
      2: `請於${formatDate(paymentExpiredDate, 'yyyy/MM/dd HH:mm')}前付款`,
    };

    if(allowExpired && status === 2) {
      return '請盡快付款'
    } else {
      return orderPrepaidPaidInfoMap[status];
    }
  }
}
